import { Component } from '@angular/core';
import { DataService } from '../../../core/services/data/data.service';
import { RouterLink } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import emailjs from 'emailjs-com';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [ RouterLink , ReactiveFormsModule],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent {

  constructor(private fb: FormBuilder , private DataService : DataService ) {}

  isArabic = false ;

  contactForm: any;

  changeLang () {
    if (this.DataService.isArabic) {
      this.isArabic = true ;
    }
    else {
      this.isArabic = false ;
    }
    setTimeout(() => { this.changeLang() }, 100) ;
  }


  showMessage: { type: string, text: string } | null = null;

  onSubmit(): void {
    if (this.contactForm.valid) {
      const formData = this.contactForm.value;
      emailjs.send("service_v9frgle", "template_rolyhdw", {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message
      }, "z4CmaoaQ4JGmHaO83") // Replace with your public key
      .then((response) => {
        this.showMessage = { type: 'success', text: 'Your message was sent successfully' };
        this.clearMessage();
      }, (error) => {
        this.showMessage = { type: 'error', text: 'Error, your message was not sent' };
        this.clearMessage();
      });
      this.contactForm.reset();
    }
  }

  clearMessage() {
    setTimeout(() => {
      this.showMessage = null;
    }, 5000);
  }


  ngOnInit(): void { 

    this.changeLang() ;

    this.contactForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(60)]],
      email: ['', [Validators.required, Validators.email, Validators.minLength(3), Validators.maxLength(60)]],
      phone: ['', [Validators.required, Validators.pattern(/^\+?[0-9]{10,15}$/)]],
      message: ['', [Validators.required, Validators.minLength(10)]]
    });
  
  }

}
